var ptBR = {
	"codeBlock.copied": "Copiado",
	"codeBlock.copyLabel": "Copiar",
	"inlineCodeBlock.copied": "Copiado",
	"inlineCodeBlock.copyLabel": "Copiar código em linha"
};

export { ptBR as default };
